import React, { useState, useEffect, useRef } from "react";
import { Button, Layout, FloatButton, message, Form, Table, Input } from "antd";
import * as XLSX from "xlsx";
import Cookies from "js-cookie";
import axios from "axios";
import { Redirect, Link } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
// import "./PayrollChecklist.css";
import "../../GlobalCss/SPF/PayrollChecklist.css";
import { BaseUrl, JsonConfig, jwtToken } from "../../Repository/BaseRepository";
import { UploadOutlined } from "@ant-design/icons";
import { routes } from "../../Utils/Utils";
const { Header, Content } = Layout;

const PayrollChecklist = () => {
  const tenantName = Cookies.get("tenant_name");
  const [reviewerSignature, setReviewerSignature] = useState("");
  const [managerSignature, setManagerSignature] = useState("");
  const [ChecklistGridData, setChecklistGridData] = useState([]);
  const [UpdatedRecords, setUpdatedRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [UnmodifiedRecords, setUnmodifiedRecords] = useState([]);
  const [payDate, setPayDate] = useState("");
  // let UnmodifiedRecords = [];
  const FetchChecklistData = async () => {
    let ChecklistData = [];
    let StaticTasksData = [];

    const CheckListURL = BaseUrl + "PayrollMasterAudit/GetPayrollChecklist";
    const CheckListResponse = await axios.get(CheckListURL, JsonConfig);
    if (
      CheckListResponse != null &&
      CheckListResponse.data.statusCode === 200
    ) {
      ChecklistData = JSON.parse(CheckListResponse.data.payload);
    }

    const StaticURL = BaseUrl + "PayrollMasterAudit/GetStaticData";
    const StaticResponse = await axios.get(StaticURL, JsonConfig);
    if (StaticResponse != null && StaticResponse.data.statusCode === 200) {
      StaticTasksData = JSON.parse(StaticResponse.data.payload);
    }
    const PaydayURL = BaseUrl + "PayrollMasterAudit/Paydate";
    const PaydateResponse = await axios.get(PaydayURL, JsonConfig);
    if (PaydateResponse != null) {
      const parsedData = PaydateResponse.data;
      setPayDate(parsedData);
    }

    let GridData = StaticTasksData.filter((eachTaskData) => {
      return eachTaskData.Task.toLowerCase().includes("sign-off") === false;
    }).map((eachTaskData) => {
      const correspondingDetail = ChecklistData.find(
        (data) =>
          data.Payroll_Activities === eachTaskData.Payroll_Activities &&
          data.Task === eachTaskData.Task
      );
      return {
        Id: eachTaskData.Id,
        Task: eachTaskData.Task,
        Preparer: correspondingDetail?.Preparer || "",
        Reviewer_1stLevel: correspondingDetail?.Reviewer_1stLevel || "",
        Reviewer_2ndLevel: correspondingDetail?.Reviewer_2ndLevel || "",
        Payroll_Activities: eachTaskData.Payroll_Activities,
        Obser_Weekly: correspondingDetail?.Obser_Weekly || "",
        Obser_BiWeekly: correspondingDetail?.Obser_BiWeekly || "",
        Numb_Weekly: correspondingDetail?.Numb_Weekly || "",
        Numb_BiWeekly: correspondingDetail?.Numb_BiWeekly || "",
      };
    });

    setChecklistGridData(GridData);
    setUnmodifiedRecords([...GridData]);
    setLoading(false);
  };

  //Functions
  const columns = [
    {
      title: "Payroll",
      dataIndex: "Task",
      editable: false,
      ellipsis: true,
      width: 120,
      render:(text, record, index) => (
        <div style={{ whiteSpace: "normal",lineHeight:"1.3" }}>{text}</div>
      )
    },
    {
      title: "Preparer",
      dataIndex: "Preparer",
      editable: true,
      ellipsis: true,
      width: 70,
    },
    {
      title: "Reviewer",
      children: [
        {
          title: "1st Level",
          dataIndex: "Reviewer_1stLevel",
          editable: true,
          ellipsis: true,
          width: 70,
          onCell: (record) => ({
            record,
            dataIndex: "Reviewer_1stLevel",
            title: "1st Level",
            editable: true,
            onBlur: () => handleSave(record),
          }),
        },
        {
          title: "2nd Level",
          dataIndex: "Reviewer_2ndLevel",
          editable: true,
          ellipsis: true,
          width: 70,
          onCell: (record) => ({
            record,
            dataIndex: "Reviewer_2ndLevel",
            title: "2nd Level",
            editable: true,
            onBlur: () => handleSave(record),
          }),
        },
      ],
    },
    {
      title: "Payroll Activities",
      dataIndex: "Payroll_Activities",
      editable: false,
      ellipsis: true,
      width: 200,
      render:(text, record, index) => (
        <div style={{ whiteSpace: "normal",lineHeight:"1.3" }}>{text}</div>
      )
    
    },
    {
      title: "Observation",
      children: [
        {
          title: "Weekly",
          dataIndex: "Obser_Weekly",
          editable: true,
          ellipsis: true,
          width: 50,
          onCell: (record) => ({
            record,
            dataIndex: "Obser_Weekly",
            title: "Observation Weekly",
            editable: true,
            onBlur: () => handleSave(record),
          }),
        },
        {
          title: "Bi-Weekly",
          dataIndex: "Obser_BiWeekly",
          editable: true,
          ellipsis: true,
          width: 50,
          onCell: (record) => ({
            record,
            dataIndex: "Obser_BiWeekly",
            title: "Observation Bi-Weekly",
            editable: true,
            onBlur: () => handleSave(record),
          }),
        },
      ],
    },

    {
      title: "Numbers",
      children: [
        {
          title: "Weekly",
          dataIndex: "Numb_Weekly",
          editable: true,
          ellipsis: true,
          width: 50,
          onCell: (record) => ({
            record,
            dataIndex: "Numb_Weekly",
            title: "Numbers Weekly",
            editable: true,
            onBlur: () => handleSave(record),
          }),
        },
        {
          title: "Bi-Weekly",
          dataIndex: "Numb_BiWeekly",
          editable: true,
          ellipsis: true,
          width: 50,
          onCell: (record) => ({
            record,
            dataIndex: "Numb_BiWeekly",
            title: "Numbers Bi-Weekly",
            editable: true,
            onBlur: () => handleSave(record),
          }),
        },
      ],
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,
        editable: col.editable,
        onBlur: () => handleSave(record),
      }),
    };
  });

  const handleSave = (record) => {
    let OldRecordIndex = UnmodifiedRecords.findIndex(
      (data) => data.uniqueId === record.uniqueId
    );

    let OldRecord =
      OldRecordIndex !== -1 ? UnmodifiedRecords[OldRecordIndex] : null;

    if (OldRecord !== null) {
      let IsModified = !Object.entries(OldRecord).every(
        ([key, value]) => record[key] === value
      );

      let CheckIndex = UpdatedRecords.findIndex(
        (data) => data.uniqueId === record.uniqueId
      );

      if (IsModified) {
        setUpdatedRecords((prevRecords) => {
          let newRecords = [...prevRecords];
          if (CheckIndex > -1) {
            newRecords[CheckIndex] = record;
          } else {
            newRecords.push(record);
          }
          return newRecords;
        });
      } else {
        if (CheckIndex > -1) {
          setUpdatedRecords((prevRecords) =>
            prevRecords.filter(
              (eachRecord) => eachRecord.uniqueId !== record.uniqueId
            )
          );
        }
      }
    }
  };

  const handleButtonClick = async () => {
    try {
      const dataToSend = ChecklistGridData.map((item) => ({
        ...item,
        Signature1: reviewerSignature,
        Signature2: managerSignature,
      }));

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}PayrollMasterAudit/PostPayrollChecklist`,
        dataToSend,
        JsonConfig
      );

      if (response.data.isSuccess === true) {
        message.success(response.data.message);
        setUpdatedRecords([]);
        FetchChecklistData();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error("An error occurred while updating records.");
    }
  };

  const handleEdit = (record, dataIndex, value) => {
    record[dataIndex] = value;
    // setEditedRecord(record);
  };
  // Define the tasksAndActivities array
  const tasksAndActivities = [
    {
      task: "New Hire/ Re-Hire",
      payrollActivities: [
        {
          name: "Extract New Hire/ Re-Hire report from spectranet and upload on Paychex",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update New Hire/ Re-Hire address info on Paychex",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review F1-Opt Emp and update the tax (exempt from SS/Medicare)",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update EE's federal tax info",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update EE's State and Local taxes info",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update EE's filing and exemptions status",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update EE's claiming exempt      (If applicable)",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update EE's bank and DD details",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update EE'S job title, start and end date",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review emp FLSA status (SN vs Paychex)",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review emp working on Remote (Update taxes)",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Follow-up with Paychex on any new State/Local additions",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Refer email from HR team on Corp EE'S job title updation",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update EE's SS, Medicare and Other tax details",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Audit (All above tasks)",
          disabledColumns: ["Preparer", "2nd Level"],
        },
        {
          name: "Match SN Pay Rate info vs Active List",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Review F1-Opt Employees taxes",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Review Emp Static data for duplicate File# and SSN entries",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
    {
      task: "BANK",
      payrollActivities: [
        {
          name: "Review the Bank/ DD detail employees wise in the file sent by Ashley as well as the Bank/ DD Tickets",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "All DD / Bank should be double checked with Void check or Bank Letter VS Pay Auth Form. Any discrepancies needs to reported.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "If any discrepancies found, do not update in Paychex until the correct Bank details is confirmed. Delete the record from Ashley's report and send emails.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review the .csv import file error if any in Paychex after the import is completed.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review employees who have opted for BOA/PPC in Ashley's email and report.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Send BOA/PPC to employees a per the request.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review the ticket created by EC for employees confirming that he/she received the PPC/BOA.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Activate the BOA/PPC account ",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Audit (All above tasks)",
          disabledColumns: ["2nd Level", "Preparer"],
        },
        {
          name: "Validate the Bank details for any exceptional email  sent by the team",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Review Emp Static data for duplicate DD entries",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
    {
      task: "Garnishment",
      payrollActivities: [
        {
          name: "Total Garnishment Received",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Terminated Employee Garnishment",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Child Suport Garnsihment",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Tax Garnsihment",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Student Loan",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Wage Garnishment",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Bankruptcy",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Garnishment Release",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Others",
          disabledColumns: ["2nd Level", "1st Level"],
        },
      ],
    },
    {
      task: "EXP Reimb",
      payrollActivities: [
        {
          name: "Download EXP from Portal",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Check for prior exp issues - Tickets or emails if any",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Consolidate EXP file and send for approval",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Send Approved file to AR & Payroll",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Create Reimb masterfile for Payroll",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Create Reimb .CSV file",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Audit (All above tasks)",
          disabledColumns: ["2nd Level", "Preparer"],
        },
        {
          name: "Check for duplicate File# and entities",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Review totals (EXP reimb file vs .CSV file)",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
    {
      task: "Health Benefits",
      payrollActivities: [
        {
          name: "Review files received from HCW",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Pro-rate the deduction based on Ben start date and Pay period",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Create .CSV file",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Upload to Paychex",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Flag Corp Emp Medicals - email from EC team",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Validate medical recovery/adjustment",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
    {
      task: "Master Time Sheet Process",
      payrollActivities: [
        {
          name: "Pull current payroll hours from VMS portal for different pay periods and update the master file",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Download Active list report from Paychex",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update new hires/missing new hires on Paychex(Follow the new hire check list)",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update master payroll sheet after getting an update from CS team regarding missing hours",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Make sure you are checking the hours carefully as any thing more than 40 hours should go as OT hours",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Classify the missing/pending approval as per legends(yellow and blue accordingly)",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update master payroll sheet after getting an update from CS team regarding missing hours",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Audit Hours (Random)",
          disabledColumns: ["2nd Level", "Preparer"],
        },
        {
          name: "Flag and check for employees having hours >40",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Flag any high Pay Rate employees >100/ hr",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Check for duplicate file#/ emp",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Compare Mastersheet hours (Current vs Prior)",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
    {
      task: "Payroll Adjustment - Arrears",
      payrollActivities: [
        {
          name: "Update the arrears sheet  for missing hours of last payroll",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Update the same on adjustment file",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Close all the tickets regarding, PTO, Last submissions, Bonus, refunds(medical, federal and State), garnishment refunds, terminations etc.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Validate Off-Cycle Payroll file",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Bonus / Comm - Check for Tax frequency - No changes in the tax frequency.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "If Bonus / Comm Tax Frequency changed - update the employee name and reason for change.",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review 401K % and other % based deduction coming out of Bonus / Comm",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Upload all the commissions, gratuity, premium and bonus details on adjustment file",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Upload all adhoc requests which we receive via email",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Corp Emp Pay Rate Increase - Add/Retro if any",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Add Recovery if any - emp shuould get his min wage",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "All the updated information on Adjustment sheet should be convert to upload format for Paychex",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Upload the info into Paychex for payroll run",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Audit Hours and Amount (Arrears file , Tickets )",
          disabledColumns: ["2nd Level", "Preparer"],
        },
        {
          name: "Review Corp Employees Pay Rate increase",
          disabledColumns: ["1st Level", "Preparer"],
        },
        {
          name: "Validate exceptional payments (Corp & W2)",
          disabledColumns: ["1st Level", "Preparer"],
        },
        {
          name: "Validate recovery if any",
          disabledColumns: ["1st Level", "Preparer"],
        },
      ],
    },
    {
      task: "Payroll Upload & Run",
      payrollActivities: [
        {
          name: "Create Batches based on Client weekend",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Import all the data from master sheet , EXP sheet to Paychex macro file",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "All the uploaded information should be converted to CSV file for Paychex",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Upload the info into Paychex for payroll run",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review pay period dates in Batches",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
    {
      task: "Payroll Preview Totals",
      payrollActivities: [
        {
          name: "Previous Pay Period: $",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Current Pay Period: $",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Review Totals to identify large difference in hours and wages.",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
    {
      task: "Payroll Preview & Submission",
      payrollActivities: [
        {
          name: "Pull preview report and send the info to team members for review, off cycle",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Validate Salaried Emp hours (memo code - M)",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Make corrections if any",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Submit payroll",
          disabledColumns: ["2nd Level", "1st Level"],
        },
        {
          name: "Validate Memo Code in Preview",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Review the Payroll preview totals VS the Mastersheet totals",
          disabledColumns: ["Preparer", "1st Level"],
        },
        {
          name: "Check for any drops - Shortfalls",
          disabledColumns: ["Preparer", "1st Level"],
        },
      ],
    },
  ];

  const EditableCell = ({
    editable,
    dataIndex,
    title,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputRef = useRef(null);

    const handleMouseEnter = () => {
      if (editable && inputRef.current) {
        inputRef.current.focus();
      }
    };

    let isDisabled = false; // Flag to determine if the cell should be disabled

    if (record && record.Task && record.Payroll_Activities) {
      tasksAndActivities.forEach((task) => {
        if (task.task === record.Task) {
          task.payrollActivities.forEach((activity) => {
            if (activity.name === record.Payroll_Activities) {
              if (activity.disabledColumns.includes(title)) {
                isDisabled = true;
              }
            }
          });
        }
      });
    } else {
      console.error("Invalid record object:", record);
    }

    return (
      <td {...restProps} onMouseEnter={handleMouseEnter}>
        {editable && !isDisabled ? (
          <Input
            ref={inputRef}
            onChange={(e) => handleEdit(record, dataIndex, e.target.value)}
            defaultValue={record[dataIndex]}
            onFocus={(e) => {
              e.stopPropagation();
            }}
          />
        ) : (
          <div
            style={
              isDisabled
                ? {
                    backgroundColor: "#f2f2f2",
                    color: "#808080",
                    padding: "12px",
                  }
                : {}
            }
          >
            {children}
          </div>
        )}
      </td>
    );
  };

  if (jwtToken === undefined) {
    return <Redirect to="/" />;
  }
  const handleExportToExcel = () => {
    try {
      const dataToSend = ChecklistGridData.map((item) => ({
        Task: item.Task,
        Preparer: item.Preparer,
        Reviewer_1stLevel: item.Reviewer_1stLevel,
        Reviewer_2ndLevel: item.Reviewer_2ndLevel,
        Payroll_Activities: item.Payroll_Activities,
        Obser_Weekly: item.Obser_Weekly,
        Obser_BiWeekly: item.Obser_BiWeekly,
        Numb_Weekly: item.Numb_Weekly,
        Numb_BiWeekly: item.Numb_BiWeekly,
      }));

      const ws = XLSX.utils.json_to_sheet(dataToSend);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Payroll Checklist");
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, "PayrollChecklist.xlsx"); // Trigger download
    } catch (error) {
      message.error("An error occurred while exporting to Excel.");
    }
  };

  useEffect(() => {
    FetchChecklistData();
    // setChecklistGridData();
  }, []);
  return (
    <>
      <Layout
        style={{
          backgroundColor: "white",
          height: "100vh",
          display: "flex",
      
        }}
      >
        <SideNavBar />
        <Layout style={{ backgroundColor: "white",   overflowY:"scroll",
         overflowX:"hidden" }}>
          <Header className="masteraudit-header-class">
            <Navbar />
          </Header>
          <Content className="masteraudit-content">
            <div className="masteraudit-allpages-class">
              <Link to={`/${tenantName}/payrollhoursaudit`}>
                <Button className="masteraudit-page-button">
                  Payroll Hours Audit
                </Button>
              </Link>
              <Link to={`/${tenantName}/finalmasteraudit`}>
                <Button className="page-button">Final Master Audit</Button>
              </Link>
              <Link to={`/${tenantName}/preview`}>
                {" "}
                <Button className="masteraudit-page-button">
                  Preview/Review
                </Button>
              </Link>
              <Button className="masteraudit-currentpage-button">
                Payroll Checklist
              </Button>
              <Link to={`/${tenantName}/audit`}>
                <Button className="masteraudit-page-button">
                  Selected Crawling
                </Button>
              </Link>
            </div>
            <div className="checklist-grid-container">
              <div className="heading-payday">
               <div > <h1 style={{ color: "#3B52DF" }}>Payday:{payDate}</h1></div>
                <div>
                <Button
                  onClick={handleButtonClick}
                  // style={{ marginLeft: "150px" }}
                  className="csv-button"
                >
                  Save all changes
                </Button>
                <Button
                  style={{ marginRight: "50px" }}
                  className="csv-button"
                  onClick={handleExportToExcel}
                >
                  Export to Excel <UploadOutlined />
                </Button>
                </div>

                {/* <FloatButton
                  tooltip={<div>Save All Changes</div>}
                  icon={<p className="save-Float-Icon">Save</p>}
                  type="primary"
                  shape="square"
                  // className="save-Float-Button"
                  onClick={handleButtonClick}
                /> */}

              </div>

              <div className="checklist-grid">
                <div className="heading-payday">
                  <Table
                    components={{
                      body: {
                        cell: EditableCell,
                      },
                    }}
                    columns={mergedColumns}
                    dataSource={ChecklistGridData}
                    bordered
                    pagination={false}
                    size="small"
                    loading={loading}
                    scroll={{ y: 400 }}
                  />
                </div>

                <div className="task-card">
                  <div className="sign-off">
                    {" "}
                    <h3 className="sign-offdiv">Sign-off</h3>
                  </div>
                  <div style={{ width: "90%", marginTop: "10px" }}>
                    <form>
                      <label>
                     <strong style={{color:"#454545"}}>Reviewer </strong>: I have verified and/or completed all tasks
                        listed above:
                      </label>
                      &nbsp; &nbsp;
                      <Input
                        className="reviewer"
                        type="text"
                        value={reviewerSignature}
                        onChange={(e) => setReviewerSignature(e.target.value)}
                        placeholder="Enter your signature"
                      />
                      <br />
                      <label>
                      <strong style={{color:"#454545"}}>Manager </strong> : I have verified all completed above:
                      </label>
                      &nbsp; &nbsp;
                      <Input
                        type="text"
                        className="manager"
                        value={managerSignature}
                        onChange={(e) => setManagerSignature(e.target.value)}
                        placeholder="Enter your signature"
                      />
                      <p>
                        Review Checklist to confirm all tasks have been signed
                        off as completed. Save backup.{" "}
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};
export default PayrollChecklist;
